import type { ButtonHTMLAttributes } from 'react';

type Tone = 'primary' | 'secondary' | 'danger' | 'quiet';

const TONES: Record<Tone, string> = {
  primary: 'bg-accent-600 text-paper hover:bg-accent-700',
  secondary: 'border border-border bg-surface text-ink hover:border-border-strong',
  danger: 'bg-danger text-paper hover:bg-danger/90',
  quiet: 'text-accent-600 underline underline-offset-4',
};

export default function Button({
  tone = 'primary',
  className = '',
  type = 'button',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { tone?: Tone }) {
  const base =
    tone === 'quiet'
      ? 'inline-flex items-center text-sm'
      : 'inline-flex items-center justify-center rounded px-4 py-2 text-sm font-medium';
  return <button type={type} className={`${base} ${TONES[tone]} ${className}`} {...props} />;
}
